export default __webpack_public_path__ + "static/ccv-16d45e1f1d7a34c09f1d706da8d3ef75.png";